import { mapState, mapGetters, mapMutations } from 'vuex'
import MultipleFileInput from '@/components/Ui/MultipleFileInput'
import Constants from '@/utils/Constants'
import Validator from '@/utils/Validator'

export default {
  name: 'TypeImage',
  components: {
    MultipleFileInput
  },
  data () {
    return {
      input: {
        attachments: []
      }
    }
  },
  mounted () {
    this.init()
    this.setValidate(this.formIsValid)
  },
  computed: {
    ...mapState({
      values: state => state.noticeForm.values
    }),
    ...mapGetters({
      permittedView: 'permission/permittedView',
    }),

    // list
    fileList () {
      let list = []
      let l = Math.min(this.input.attachments.length + 1,
        Constants.Notice.MaxImageFile)
      for (let i = 0; i < l; i++) {
        let n = i + 1
        list.push({
          name: 'inpImageFile' + n,
          file: this.input.attachments[i]
        })
      }
      return list
    },

    // validate
    formIsValid () {
      return this.input.attachments.length &&
        Validator.validFile(this.input.attachments[0])
    },

    // post用にjsonbを取得
    jsonb () {
      let jsonb = {}
      if (this.input.attachments.length) {
        jsonb.attachments = this.input.attachments
      }
      return jsonb
    }
  },
  watch: {
    // 入力値が変更されたらモジュール全体のバリデート結果をstoreに保持
    input: {
      handler: function (to) {
        this.setValidate(this.formIsValid)
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations({
      setValidate: 'noticeForm/setValidate'
    }),

    init () {
      Object.keys(this.input)
        .forEach(key => {
          if (this.values.inpDeliveryContents &&
            this.values.inpDeliveryContents[key]) {
            this.input[key] = this.values.inpDeliveryContents[key]
          }
        })
    },

    // ファイル登録
    showDeleteFileButton (index) {
      if (index < this.input.attachments.length - 1) {
        return true
      } else {
        return typeof this.input.attachments[index] === 'object'
      }
    },
    changeFile ({index, file}) {
      if (this.input.attachments.length === index) {
        this.input.attachments.push(file)
      } else {
        this.$set(this.input.attachments, index, file)
      }
      // console.log('changeImageFile | input.attachments', this.input.attachments)
    },
    deleteFile ({index}) {
      this.input.attachments.splice(index, 1)
      // console.log('deleteImageFile | index : ' + index, this.input.attachments)
    },
  }
}
